import React from 'react';
import PropTypes from 'prop-types';
import { useLanguage } from '../../contexts/LanguageContext';

// Names are what a screen reader announces, and what shows on hover.
const COLORS = [
    ['#ffffff', 'white'], ['#f6d4b5', 'beige'], ['#f7a56f', 'peach'],
    ['#ff999a', 'pink'], ['#ffd800', 'yellow'], ['#ff0000', 'red'],
    ['#ff9900', 'orange'], ['#a80000', 'dark_red'], ['#fbfabc', 'cream'],
    ['#cae8ff', 'light_blue'], ['#c4f826', 'lime'], ['#beb9e2', 'lavender'],
    ['#acbd84', 'sage'], ['#8c96c1', 'blue_grey'], ['#05aa02', 'green'],
    ['#2c3378', 'navy'], ['#660066', 'purple'], ['#cba01a', 'gold'],
    ['#0099ff', 'sky_blue'], ['#a87832', 'light_brown'], ['#0000cc', 'blue'],
    ['#efd8ab', 'sand'], ['#000066', 'dark_blue'], ['#ab9b80', 'taupe'],
    ['#cccccc', 'light_grey'], ['#c48d5b', 'caramel'], ['#999999', 'grey'],
    ['#715a4c', 'stone'], ['#666666', 'dark_grey'], ['#754e2b', 'brown'],
    ['#482017', 'dark_brown'], ['#000000', 'black'], ['#8B0000', 'burgundy'],
    ['#E9967A', 'salmon'], ['#8FBC8F', 'mint'], ['#483D8B', 'indigo'],
    ['#2F4F4F', 'dark_teal'], ['#00CED1', 'turquoise'],
];

const ColorPalette = ({ selectedColor, onChange }) => {
    const { translate } = useLanguage();

    return (
        <div className="color-palette" role="group" aria-label={translate('color_palette')}>
            {COLORS.map(([color, nameKey]) => {
                const name = translate(`color_${nameKey}`);
                return (
                    <button
                        key={color}
                        type="button"
                        style={{ backgroundColor: color }}
                        className={`color-swatch ${selectedColor === color ? 'selected' : ''}`}
                        onClick={() => onChange(color)}
                        aria-pressed={selectedColor === color}
                        aria-label={name}
                        title={name}
                    />
                );
            })}
        </div>
    );
};

ColorPalette.propTypes = {
    selectedColor: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ColorPalette;
